import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Stack,
  Typography,
} from '@mui/material'
import React from 'react'
import { TooltipRenderProps } from 'react-joyride'
import ReactMarkdown from 'react-markdown'

import { IOnboardingJoyrideStep } from '../onboardingJoyride.types'

export interface IGeneralJoyrideTooltipProps extends Omit<TooltipRenderProps, 'step'> {
  step: IOnboardingJoyrideStep
}

export function GeneralJoyrideTooltip({
  continuous,
  step,
  skipProps,
  closeProps,
  primaryProps,
}: IGeneralJoyrideTooltipProps) {
  return (
    <Card sx={{ minWidth: 300 }}>
      <CardActionArea>
        {step.imageUri && <CardMedia component="img" height="fit-content" image={step.imageUri} alt="joyride_img" />}
        <CardContent>
          <Stack gap={2}>
            <ReactMarkdown
              components={{
                p: ({ children, ...props }) => (
                  <Typography variant="h6" {...props}>
                    {children}
                  </Typography>
                ),
              }}
              className="line-break"
            >
              {step?.title ?? ''}
            </ReactMarkdown>
            <ReactMarkdown
              components={{
                p: ({ children, ...props }) => (
                  <Typography variant="h6" {...props}>
                    {children}
                  </Typography>
                ),
              }}
              className="line-break"
            >
              {step?.content ?? ''}
            </ReactMarkdown>
          </Stack>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Box width="100%" display="flex" justifyContent="space-between">
          <Button {...skipProps} variant="outlined">
            {closeProps.title}
          </Button>
          <ButtonGroup>
            {continuous && (
              <Button variant="contained" color="primary" {...primaryProps}>
                {`${primaryProps.title}`}
              </Button>
            )}
          </ButtonGroup>
        </Box>
      </CardActions>
    </Card>
  )
}
